import Vue from 'vue';
import axios from 'axios'; 
 
export default {
  name: 'GisSettings',
  data: function () {
    return {
      maps: [],
      serverTypes: [],
      isInComm: false,
      settings: {
        serverType: -1,
        gisLink: 'http://',
        gisUser: '',
        gisPassword: ''
      },
      message: ''
    }
  },
  created() {
    //this.getMaps();
    this.getServerTypes();
    this.getGisSettings();
  },
  methods: {
    getServerTypes() {
      axios.post('/GIS/GetServerTypes')
        .then(response => {
          if (response.data.data.status == 0) {
            this.serverTypes = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getGisSettings() {
      axios.post('/GIS/GetGisSettings')
        .then(response => {
          if (response.data.data.status == 0) {
            this.settings = response.data.settings;
            if (this.settings.serverType < 0 && this.serverTypes.length > 0)
              this.settings.serverType = this.serverTypes[0].id;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    saveGisSettings() {
      this.isInComm = true;
      axios.post('/GIS/SaveGisSettings', {
        Servertype: this.settings.serverType, GisLink: this.settings.gisLink, GisUser: this.settings.gisUser, GisPassword: this.settings.gisPassword,
        WebGisLink: this.settings.webGisLink, WebGisLogin: this.settings.webGisLogin, WebGisPassword: this.settings.webGisPassword
      })
        .then(response => {
          if (response.data.data.status == 0) {
            this.closeWithMessage(this.$t('messages.GISSavedSuccess'), 0, 1500);
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
          this.isInComm = false;
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    close() {
      this.$router.go(-1);
    },
    closeWithMessage(msg, type, timeout = 3000) {
      this.message = msg;
      if (type == 1)
        this.message += ' If the problem repeats please contact Support';
      this.$alertMsg(msg);
      setTimeout(function () { this.close(); }.bind(this), timeout);
    },

  }
}
